import React from 'react';
import { combineClassNames } from '../../../app/functions';
import './index.scss';

const Tabs = ({ activeTab, tabsList, onTabSelect }) => (
  <div className="filter-tabs-wrapper">
    {tabsList.map(({ key, title, isDisabled = false }) => (
      <button
        key={key}
        type="button"
        className={combineClassNames(
          'filter-tab',
          activeTab === key ? 'selected' : 'not-selected',
          isDisabled && 'disabled',
        )}
        onClick={() => !isDisabled && onTabSelect(key)}
      >
        {title}
      </button>
    ))}
  </div>
);

export default Tabs;
